export type ProgressAccent = 'zone' | 'race' | 'metal' | 'mineral' | 'gas' | 'energy' | 'success' | 'warning' | 'danger' | 'info';

/**
 * Shared by ProgressBar and ProgressRing so the accent scale can never drift
 * apart. `zone` reads `--zone-accent`; the rest are resource and status
 * tokens (see @docs/design-system.md §1.4/§1.5). Full class strings are
 * written out literally — Tailwind's content scanner cannot see classes
 * assembled via string interpolation.
 */
export const PROGRESS_ACCENT_TEXT_CLASSES: Record<ProgressAccent, string> = {
    zone: 'text-[color:var(--zone-accent)]',
    race: 'text-[color:var(--race-accent)]',
    metal: 'text-metal',
    mineral: 'text-mineral',
    gas: 'text-gas',
    energy: 'text-energy',
    success: 'text-status-success',
    warning: 'text-status-warning',
    danger: 'text-status-danger',
    info: 'text-status-info',
};

export const PROGRESS_ACCENT_BG_CLASSES: Record<ProgressAccent, string> = {
    zone: 'bg-[color:var(--zone-accent)]',
    race: 'bg-[color:var(--race-accent)]',
    metal: 'bg-metal',
    mineral: 'bg-mineral',
    gas: 'bg-gas',
    energy: 'bg-energy',
    success: 'bg-status-success',
    warning: 'bg-status-warning',
    danger: 'bg-status-danger',
    info: 'bg-status-info',
};
